import React, { useEffect } from 'react';
import './accessiway.scss';

const AccessiwayScript = () => {
  useEffect(() => {
    const script = document.createElement('script');
    const targetElement =
      document.querySelector('body') || document.querySelector('head');

    script.src = 'https://embeds.acswapp.com/accessibility/app.js';
    script.async = true;

    targetElement.appendChild(script);

    return () => {
      targetElement.removeChild(script);
    };
  }, []);

  return <></>;
};

export default AccessiwayScript;
